import MitraDJP from './MitraDJP'

export default MitraDJP